module.exports = __webpack_public_path__ + "static/media/LOGO-AUTOPECAS.8669642e.png";